import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../../Configuration/configuration.service';
import { BaseEntityModel } from '../../Data/Models/Common/base-entity-model';
import { Email_Configuration_Model } from '../../Data/Models/Email_Configuration_Model/Email_Configuration_Model';
@Injectable({
  providedIn: 'root'
})
export class Email_Configuration_Service {
  baseURL: string;
  constructor(private http: HttpClient, private configService: ConfigurationService) {
    this.baseURL = this.configService.getAPIBaseUrl();
  }
  RetriveEmailConfig(Central_UserId: number): Observable<BaseEntityModel<Email_Configuration_Model>> {
    debugger
    return this.http.get<BaseEntityModel<Email_Configuration_Model>>(`${this.baseURL}/Email_Configuration/FetchEmailConfigDetailsById?Central_UserId=${Central_UserId}`);
  }
  InsertUpdateEmailConfig(formData: Email_Configuration_Model): Observable<BaseEntityModel<Email_Configuration_Model>> {
    return this.http.post<BaseEntityModel<Email_Configuration_Model>>(`${this.baseURL}/Email_Configuration/InsertUpdateEmailConfigDetails`, formData);
  }
}
